import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import classnames from 'classnames';
import FollowingWatchIcon from '../FollowingWatch';
import CircleWrap from '../../CircleWrap';
import s from './EyeDisc2.scss';
const EyeDisc2 = (_param)=>{
    var { className  } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(CircleWrap, {
        circleClassName: classnames(s['disc'], className),
        size: props.size
    }, /*#__PURE__*/ React.createElement(FollowingWatchIcon, _extends({}, props, {
        disableDefaultColors: true
    })));
};
EyeDisc2.displayName = 'EyeDisc2';
export default EyeDisc2;
